



























import { Component, Vue, Watch } from 'vue-property-decorator';
import navigation from '@/components/navbars/navigation.vue';
import SearchBar from '@/pages/search/components/search-bar.vue';

@Component({
	components: {
		SearchBar,
		navigation,
	},
})
export default class SecondaryNavigation extends Vue {
	public navButtonFont = true;

	public smallScreen = window.innerWidth;

	public created() {
		window.addEventListener('resize', this.myEventHandler);
	}
	public destroyed() {
		window.removeEventListener('resize', this.myEventHandler);
	}
	public myEventHandler(e) {
		this.smallScreen = e.target.innerWidth;
	}
}
